var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu__container" },
    [
      _c(
        "el-aside",
        { class: _vm.asideWidthClass },
        [
          _c("logo", { attrs: { collapsed: _vm.collapse } }),
          _vm._v(" "),
          _c(
            "el-menu",
            {
              attrs: {
                collapse: _vm.collapse,
                mode: "vertical",
                router: true,
                "default-active": _vm.defaultActiveMenuItem,
              },
            },
            [
              _c("section-separator"),
              _vm._v(" "),
              _vm._l(_vm.filteredMenuItems, function (menuItem, index) {
                return [
                  menuItem.name === "CustomerProfile"
                    ? _c("section-separator", {
                        key: "separator-" + menuItem.name,
                        attrs: { title: "Account Info", padded: _vm.collapse },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { key: menuItem.name, staticClass: "border-box" },
                    [
                      _vm.collapse
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "collapsed__menu-item__container flex__center",
                              attrs: { index: menuItem.index.toString() },
                            },
                            [
                              _c("menu-item-collapsed", {
                                attrs: {
                                  index: menuItem.index.toString(),
                                  icon: menuItem.icon,
                                  "icon-hovered": menuItem.iconHovered,
                                  route: {
                                    name: menuItem.name,
                                    params: { id: _vm.customer.id },
                                  },
                                  description: _vm.$t(menuItem.i18n),
                                },
                              }),
                            ],
                            1
                          )
                        : _c("menu-item", {
                            attrs: {
                              index: menuItem.index.toString(),
                              icon: menuItem.icon,
                              "icon-hovered": menuItem.iconHovered,
                              route: {
                                name: menuItem.name,
                                params: { id: _vm.customer.id },
                              },
                              description: _vm.$t(menuItem.i18n),
                            },
                          }),
                    ],
                    1
                  ),
                ]
              }),
              _vm._v(" "),
              !_vm.collapse ? _c("section-separator") : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "border-box" },
                [
                  _vm.collapse
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "collapsed__menu-item__container flex__center",
                        },
                        [
                          _c("menu-item-collapsed", {
                            attrs: {
                              index: "feature-requests",
                              icon: require("@/assets/icons/new-ui/left-navbar/requests.svg"),
                              "icon-hovered": require("@/assets/icons/new-ui/left-navbar/requests__hovered.svg"),
                              route: { name: "FeatureRequests" },
                              description: "Feature Requests",
                            },
                          }),
                        ],
                        1
                      )
                    : _c("menu-item", {
                        attrs: {
                          index: "feature-requests",
                          icon: require("@/assets/icons/new-ui/left-navbar/requests.svg"),
                          "icon-hovered": require("@/assets/icons/new-ui/left-navbar/requests__hovered.svg"),
                          route: { name: "FeatureRequests" },
                          description: "Feature Requests",
                        },
                      }),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("menu-footer", { on: { collapseNotification: _vm.setCollapse } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }